<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="container">
        <div class="info-box">
            <div style="width: 100%; text-align: center;margin-bottom: 40px;"><img src="../assets/dc_sinovac_logo.svg"
                    alt="" style="width: 60%;"></div>
            <a-input class="username a-input" v-model:value="username" placeholder="用户名">
                <template #prefix>
                    <user-outlined />
                </template>
            </a-input>
            <a-input-password class="password a-input" v-model:value="password" placeholder="密码">
                <template #prefix>
                    <LockOutlined />
                </template>
            </a-input-password>
            <div class="button-box"><button @click="login()">登录</button></div>
        </div>
    </div>
</template>

<script setup>
import { UserOutlined, LockOutlined } from '@ant-design/icons-vue';
import { notification } from 'ant-design-vue';
import { ref } from 'vue'
import axios from 'axios';
import SHA1 from 'crypto-js/sha1';
import { useRouter } from 'vue-router'
import {RequestUrl} from '../api'

const username = ref('');
const password = ref('');
const password_sha1 = ref('');
const router = useRouter()

const login = () => {
    password_sha1.value = SHA1(password.value).toString();//sha1加密
    axios({
        method: 'get',
        url: `${RequestUrl}public/loginAjax`,
        params: {
            username: username.value,
            password: password_sha1.value
        }
    })
        .then(function (res) {
            if (res.data.stateCode === 1000) {
                var token = res.data.content.token
                router.push({
                    path: '/manage',
                    query: { token:token}
                });
            } else {
                var token_test = res.data.content.token//测试用
                notification['error']({
                    message: '错误--' + res.data.stateCode,
                    description:
                        res.data.content,
                });
                router.push({
                    path: '/manage',
                    query: { token:token_test}
                });//测试用
            }
        })
        .catch(function (error) {
            notification['error']({
                message: '出错了',
                description:
                    error.errMsg,
            });

        });
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
    position: relative;
    width: 100%;
    height: 100vh;
    background-image: url('../assets/bg.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

}

.info-box {
    position: absolute;
    right: 4%;
    top: 30%;
    height: 400px;
    width: 600px;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 5px rgb(170, 50, 50);
    padding: 40px 20px 20px 20px;
    display: flex;
    flex-direction: column;

}

.a-input {
    height: 60px;
    font-size: 15px;
    margin-bottom: 10px;
}

.button-box {
    width: 100%;
    text-align: center;
    margin-top: 25px;
}

button {
    width: 95%;
    height: 40px;
    background-color: rgb(207, 58, 58);
    border: none;
    border-radius: 5px;
    color: white;
    cursor: pointer;
}

button:hover {
    background-color: rgba(207, 58, 58, 0.438);

}
</style>
